// Попап "ловушка" для тех, кто много пользуется демо-формами с адресами (clean & suggestions).
// Появляется, если незалогиненный пользователь использует демо-форму с адресами
// более 5 раз в течение сесии.
// После закрытия не появляется до следующей сессии (тогда отсчет использований начинается сначала).
// Не показывается для авторизованных пользователей.

import basePopup from "../base-popup";
import Analytics from "../../../marketing/analytics";

const supportLink = `https://support.dadata.ru/knowledge-bases/4/articles/
2691-kak-obrabotat-fajl-standartizatsiya`;

const template = /* html */`
    <transition name="fade">
        <base-popup
            id="demo-form-popup"
            v-cloak
            variant="closable-fullscreen-mobile"
            :xl="true"
            @closed-popup="handleClose"
            v-show="isActive"
        >
            <h3 class="mb-1">
                Обрабатывайте адреса пачкой. За секунды
            </h3>
            <p>
                Если вам нужны данные о множестве адресов, не обязательно вводить их по одному.
                Можно загрузить excel-файл со списком адресов и мигом обработать.
                Вы получите документ с теми же данными, что видите в демоформе.
                Это обойдется в 15 копеек за адрес (100 штук — 15 ₽).
                Подробности — <a :href="supportLink">в инструкции по обработке файлов</a>.
            </p>
            <p class="mb-0">
                А если хотите вводить адреса вручную, можно убрать это сообщение
                навсегда — так будет удобнее. Просто
                <a
                    href="#registration_popup"
                    class="js-show-popup"
                >зарегистрируйтесь в «Дадате»</a>
                или <a
                    href="#authorization_popup"
                    class="js-show-popup"
                >войдите в личный кабинет</a>.
            </p>
            <button
                class="mt-1_5 button-clean button-clean--bordered hoverable close"
                @click="handleClose"
            >
                Понятно
            </button>
        </base-popup>
    </transition>
`;

export default {
    template,
    props: {
        storageKey: {
            type: String,
            required: true,
        },
        goalName: {
            type: String,
            required: true,
        },
        formUsageTimes: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            supportLink,
            isActive: false,
            watchUsage: true,
        };
    },
    components: { basePopup },
    mounted() {
        const currentUsage = JSON.parse(
            window.sessionStorage.getItem(this.storageKey),
        );
        this.watchUsage = !window.DA.user.isAuthenticated && currentUsage <= 5;
        if (window.DA.user.isAuthenticated) {
            window.sessionStorage.removeItem(this.storageKey);
        }
    },
    methods: {
        handleClose() {
            this.watchUsage = false;
            this.isActive = false;
        },
    },
    watch: {
        formUsageTimes() {
            if (!this.watchUsage) return;

            const currentUsage = JSON.parse(window.sessionStorage.getItem(this.storageKey));
            window.sessionStorage.setItem(this.storageKey, currentUsage + 1);
            if (currentUsage >= 5) {
                this.isActive = true;
                Analytics.reachGoal(this.goalName);
            }
        },
    },
};
